import { Box, SvgIcon } from '@volue/wave-react';
import React from 'react';

import { getLoadFlowDetailsGridElementsRequiringAttention } from '@/features/execute-calculation-set/overmind/calculation/evaluation/loadFlow/attentionRequired';
import { useAppState } from '@/overmind';

export function LoadFlowAttentionWarningCounter() {
  const evaluatedGridElements =
    useAppState().calculation.gridElementsDetailsByCalculationType;
  const attentionStatuses =
    useAppState().calculation.gridElementsAttentionStatuses;
  const isEvaluated =
    evaluatedGridElements.type === 'EVALUATED' &&
    attentionStatuses.type === 'AVAILABLE';

  return (
    <span
      data-component={LoadFlowAttentionWarningCounter.name}
      style={{ display: 'contents' }}
    >
      {isEvaluated && (
        <Box
          data-testid={loadFlowAttentionWarningCounterId}
          css={{ color: '$colorOrange70' }}
        >
          <SvgIcon iconName="warning" className="mRs" />
          {
            getLoadFlowDetailsGridElementsRequiringAttention(
              evaluatedGridElements.gridElementsDetails,
              attentionStatuses.byCalculationType.loadFlow
            ).length
          }
        </Box>
      )}
    </span>
  );
}

export const loadFlowAttentionWarningCounterId =
  'loadflow-attention-needed-counter';
